export const IS_CREATE_SUBCATEGORY = "IS_CREATE_SUBCATEGORY";
export const IS_UPDATE_SUBCATEGORY = "IS_UPDATE_SUBCATEGORY";
export const SUBCATEGORY_LIST = "SUBCATEGORY_LIST";
export const SUBCATEGORY_LIST_META = "SUBCATEGORY_LIST_META";
export const IS_SUBCATEGORY_LIST_LOADING = "IS_SUBCATEGORY_LIST_LOADING";
export const IS_SUBCATEGORY_STATUS_UPDATING = "IS_SUBCATEGORY_STATUS_UPDATING";
export const AFTER_CREATED = "AFTER_CREATED";
export const AFTER_UPDATED = "AFTER_UPDATED";
export const AFTER_DELETED = "AFTER_DELETED";
